import classes from '../product-view.module.scss';
import Modal from '@next-app/components/elements/Modal/Modal';
import ProductModal from '../ProductModal';
import { ProductModalsProps } from '@next-app/interface/PDP/PDPProductView';

const DesktopProductModal = (props: ProductModalsProps) => {
  const { data, serverUrl, modalCurrentImage } = props;
  return (
    <Modal
      showHeader={false}
      id="viewLarger"
      contentClass="ll-large"
      headingTagName="4"
      wrapperClass={`${classes['modal-dialog-wrapper']}`}
      data-testid="desktop-modal"
    >
      <ProductModal
        data={data}
        serverUrl={serverUrl}
        modalCurrentImage={modalCurrentImage}
      />
    </Modal>
  );
};

export default DesktopProductModal;
